module.exports = __webpack_public_path__ + "static/img/jx2.0e17ffb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx2.png
// module id = QFqg
// module chunks = 0